import React from 'react';

import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import TournamentHeaderTabs from '@/tournaments/components/tournament-header-tabs/TournamentHeaderTabs';

export function TournamentHeader({ active }) {
    return (
        <UserBoardHeader pageFixerClassName={'tabs'}>
            <TournamentHeaderTabs active={active} />
        </UserBoardHeader>
    );
}
